import React from 'react';
import { Link } from 'react-router-dom';

function DreamSubjectCard({ categoryId, subject }) {
  return (
    <Link
      to={`/fortune/dream/${categoryId}/${subject.id}`}
      className="fortune-card dream-subject-card"
      style={{ textDecoration: 'none' }}
    >
      <div className="card-emoji">{subject.emoji}</div>
      <h3 className="card-title">{subject.name}</h3>
      <p className="card-period">{subject.summary}</p>
      <span className="scenario-count">{subject.scenarios.length}가지 해몽</span>
    </Link>
  );
}

export default DreamSubjectCard;
